import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import NavigationDrawer from '@/components/NavigationDrawer.vue';
let MonsterNavigation = class MonsterNavigation extends Vue {
    constructor() {
        super(...arguments);
        this.items = [
            // {
            //   title: 'Introduction',
            //   icon: 'fa-journal-whills',
            //   route: '/monsters'
            // },
            // {
            //   title: 'Creating Encounters',
            //   icon: 'fa-pencil-ruler',
            //   route: '/monsters/creatingEncounters'
            // },
            {
                title: 'Monsters',
                icon: 'fa-paw',
                route: '/rules/snv'
            },
            {
                title: 'More coming soon...',
                icon: 'fa-toolbox'
            }
            // {
            //   title: 'Changelog',
            //   icon: 'fa-list',
            //   route: '/monsters/changelog'
            // }
        ];
    }
};
MonsterNavigation = __decorate([
    Component({
        components: {
            NavigationDrawer
        }
    })
], MonsterNavigation);
export default MonsterNavigation;
